import { useSelector } from "react-redux";
import "./MobileMenu.css";
import { Link, useLocation } from "react-router-dom";
import SlIcon from "@shoelace-style/shoelace/dist/react/icon";
import { selectStudent } from "../../reduxSlices/studentSlice";
import Translatable from "../Translatable/Translatable";

const MobileMenu = () => {
  const location = useLocation();
  const student = useSelector(selectStudent);
  return (
    <div className="mobile-menu">
      <div className="mobile-wrapper-menu flex items-center justify-center">
        {student.mostrarHorarios && 
        <>
        <Link
          to="/calendario"
          className={`mobile-menu-link ${location.pathname === "/calendario" ? "mobile-menu-link-active" : ""}`}
        >
          <SlIcon name="calendar"></SlIcon>
          <span>
            <Translatable as="span" capitalize>Calendario</Translatable>
          </span>
        </Link>
        <div className="mobile-menu-divider"></div>
        </>}
        <Link to="/" className={`mobile-menu-link ${location.pathname === "/" ? "mobile-menu-link-active" : ""}`}>
          <SlIcon name="card-list"></SlIcon>
          <span>
            <Translatable as="span" capitalize>Oferta de cursos</Translatable>
          </span>
        </Link>
      </div>
    </div>
  );
};

export default MobileMenu;
